/* eslint-disable import/prefer-default-export */
/* eslint-disable no-param-reassign */
const transformVideo = (video, callback) => {
  console.log('===start transforming (2D Canvas with Preprocessing)===')

  // 確保影片可以跨來源讀取像素
  video.crossOrigin = 'Anonymous'

  // 建立可見的 Canvas，並取代原本的 video 元素
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  video.insertAdjacentElement('afterend', canvas)
  // 解決 Canvas 過大問題：設定顯示尺寸，使其符合父容器寬度
  canvas.style.width = '100%'
  canvas.style.height = 'auto'

  video.style.display = 'none'

  // --- 狀態與設定 ---
  let isProcessing = false
  let isReadyToPlay = false
  // eslint-disable-next-line no-unused-vars
  let animationFrameId = null
  const BLACK_THRESHOLD = 30
  const FRAME_RATE = 30 // 假設的影片幀率

  // 建立一個用於快取遮罩資料的陣列。注意：這可能會消耗大量記憶體。
  const maskCache = []

  // 建立一個離屏 Canvas，用於在播放時暫存單一畫格的遮罩
  const offscreenMaskCanvas = document.createElement('canvas')
  const offscreenMaskCtx = offscreenMaskCanvas.getContext('2d')

  /**
   * 渲染迴圈
   */
  function processFrame() {
    if (!isReadyToPlay || video.paused || video.ended) {
      animationFrameId = null
      return
    }

    // 1. 先畫上原始影片的右半部
    ctx.drawImage(
      video,
      video.videoWidth / 2,
      0, // 來源: 影片右半部
      video.videoWidth / 2,
      video.videoHeight,
      0,
      0, // 目標: 整個 Canvas
      canvas.width,
      canvas.height
    )

    // 計算當前應該顯示哪一幀的遮罩
    const currentFrame = Math.floor(video.currentTime * FRAME_RATE)
    const maskData = maskCache[currentFrame]

    if (!maskData) return // 如果快取中沒有對應的幀，則跳過

    // 2. 設定合成模式為 'destination-in'
    // 這個模式會讓新繪製的圖像（遮罩）的 alpha 通道作用於已有的圖像（影片）上。
    // 我們的遮罩資料，不透明部分會保留原影片像素，透明部分會使其透明。
    ctx.globalCompositeOperation = 'destination-in'

    // 3. 將快取的遮罩資料畫到離屏 Canvas，再畫到主 Canvas
    offscreenMaskCtx.putImageData(maskData, 0, 0)
    ctx.drawImage(offscreenMaskCanvas, 0, 0)

    // 4. 恢復預設的合成模式，以免影響下一次繪製
    ctx.globalCompositeOperation = 'source-over'

    // 5. 請求下一幀動畫
    animationFrameId = requestAnimationFrame(processFrame)
  }

  /**
   * 階段二：設定同步播放
   */
  function setupPlayback() {
    isReadyToPlay = true
    canvas.width = video.videoWidth / 2
    canvas.height = video.videoHeight
    offscreenMaskCanvas.width = canvas.width
    offscreenMaskCanvas.height = canvas.height

    // 解決無法播放問題：在播放前將影片時間重設為開頭
    video.currentTime = 0
    video.play()
    processFrame() // 啟動渲染迴圈
  }

  /**
   * 階段一：預處理影片，生成遮罩資料陣列
   */
  async function preprocessVideo() {
    isProcessing = true
    console.log('Preprocessing started... This may consume significant memory.')

    const { videoWidth } = video
    const { videoHeight } = video
    const canvasWidth = videoWidth / 2
    const canvasHeight = videoHeight

    // 建立用於生成遮罩的離屏 Canvas
    const maskCanvas = document.createElement('canvas')
    maskCanvas.width = canvasWidth
    maskCanvas.height = canvasHeight
    const maskCtx = maskCanvas.getContext('2d', { willReadFrequently: true })

    // 逐幀處理
    video.pause()
    video.currentTime = 0

    for (let i = 0; i < video.duration * FRAME_RATE; i += 1) {
      video.currentTime = i / FRAME_RATE
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) => {
        video.onseeked = resolve
      })

      // 繪製左半部到 mask canvas
      maskCtx.drawImage(
        video,
        0,
        0,
        canvasWidth,
        videoHeight,
        0,
        0,
        canvasWidth,
        canvasHeight
      )

      // 分析像素並生成帶有透明度的遮罩資料
      const imageData = maskCtx.getImageData(0, 0, canvasWidth, canvasHeight)
      const { data } = imageData
      for (let p = 0; p < data.length; p += 4) {
        const isBlack =
          data[p] < BLACK_THRESHOLD &&
          data[p + 1] < BLACK_THRESHOLD &&
          data[p + 2] < BLACK_THRESHOLD
        // 顏色不重要，關鍵是 Alpha 通道。黑色區域透明，其餘不透明。
        data[p + 3] = isBlack ? 0 : 255
      }
      // 將處理好的該畫格遮罩資料存入快取陣列
      maskCache.push(imageData)
    }

    console.log(maskCache)
    console.log(`Preprocessing finished. Cached ${maskCache.length} frames.`)
    if (maskCache) {
      callback(maskCache)
      return maskCache
    }
    setupPlayback()
    return maskCache
  }

  // 監聽影片元數據載入完成事件，開始預處理
  video.addEventListener('loadedmetadata', () => {
    console.log('loadedmetadata')
    if (video.duration && !isProcessing) {
      preprocessVideo().catch(console.error)
    }
  })
}

export default { transformVideo }
